import { gqlTagGira } from '@atlassian/jira-issue-fetch-services-common/src/services/issue-gira-data/gira-fragments';

// This gqlTagGira is a non-apollo usage tag that still generates types under '__generated_apollo__' folder
// https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/docs/playbook/graphql.md
export const ISSUE_NAVIGATOR_PLUGGABLE_ITEMS_QUERY = gqlTagGira`
  query IssueNavigatorPluggableItemsQuery($first: Int!) {
    jiraWebSection(input: { location: JIRA_NAVIGATOR }) {
      webItems(first: $first) {
        pageInfo {
          hasNextPage
        }
        totalCount
        nodes {
          id
          label
          tooltip
          iconUrl
          target {
            type
            addonKey
            moduleKey
            ...on JiraWebItemTargetDialogModule {
              targetKey
            }
          }
        }
      }
    }
  }
`;
